import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import { getReferralLogs } from "store/locationLog/thunk";
import countryApi from "api/countryApi";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  APP_TYPE_OPTIONS,
  COLOR_REFERRAL_LOG_STATUS,
  COLOR_USER_TYPE_REFERRAL_LOG,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_OPTION_SOURCE_APP,
  LIST_USER_LOG_TYPE_OPTION,
  REFERRAL_LOG_STATUS,
  USER_TYPE_REFERRAL_LOG_OPTION,
  getOptionImage,
  getPlatFormImage,
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import countries from "helpers/countries";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import GroupInfoUser from "components/Common/GroupInfoUser";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const ReferralLogList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    // "sort[createdAt]": withDefault(StringParam, `desc`),
    // order_by: withDefault(StringParam, `DESC`),
    // date_version: withDefault(StringParam, ''),
    nickname: withDefault(StringParam, ""),
    email: withDefault(StringParam, ""),
    address: withDefault(StringParam, ""),
    uuid: withDefault(StringParam, ""),
    device_model: withDefault(StringParam, ""),
    ip: withDefault(StringParam, ""),
    platform: withDefault(StringParam, ""),
    device_os: withDefault(StringParam, ""),
    app_name: withDefault(StringParam, ""),
    country_code: withDefault(StringParam, ""),
    status: withDefault(StringParam, ""),
    is_active: withDefault(StringParam, ""),
    user_type: withDefault(StringParam, ""),
    start_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    end_date: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    type: withDefault(StringParam, ""),
  });

  const LIST_SOURCE_APP_LANG =
    LIST_OPTION_SOURCE_APP?.map((item: any) => ({
      value: item?.value,
      label: t(item?.label),
    })) || [];

  const [nicknameSearch, setNicknameSearch] = useState<string>(
    query?.nickname || ""
  );
  const [emailSearch, setEmailSearch] = useState<string>(query?.email || "");
  const [addressSearch, setAddressSearch] = useState<string>(
    query?.address || ""
  );

  const [IPSearch, setIPSearch] = useState<string>(query?.ip || "");
  const [uuidSearch, setUUIDSearch] = useState<string>(query?.uuid || "");
  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.device_model || ""
  );

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.platform)
    )[0]
  );

  const [sourceAppSearch, setSourceAppSearch] = useState<any>(
    LIST_SOURCE_APP_LANG?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const [statusSearch, setStatusSearch] = useState<any>(
    LIST_SOURCE_APP_LANG?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.device_os)
    )[0]?.value || ""
  );

  const [userTypeSearch, setUserTypeSearch] = useState<any>(
    USER_TYPE_REFERRAL_LOG_OPTION?.find(
      (item) => item?.value === query?.user_type
    )?.value ?? ""
  );
  const [typeSearch, setTypeSearch] = useState<Option | any>(
    LIST_USER_LOG_TYPE_OPTION?.find((item) => item?.value === query?.type)
      ?.value ?? ""
  );
  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [start_date, end_date] = dateSearch;

  const [linkImage, setLinkImage] = useState<string>("");
  const [countrySearch, setCountrySearch] = useState<any | null>(null);
  const [listCountry, setListCountry] = useState<any>([]);

  const selectLayoutState = (state: any) => state.LocationLog;
  const LocationLogProperties = createSelector(selectLayoutState, (state) => ({
    referralLogs: state.referralLogs,
    isReferralLogLoading: state.isReferralLogLoading,
    isReferralLogSuccess: state.isReferralLogSuccess,

    error: state.error,
  }));

  // Inside your component
  const { referralLogs, isReferralLogLoading } = useSelector(
    LocationLogProperties
  );

  function loadTableData() {
    dispatch(getReferralLogs(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    setQuery({
      ...query,
      nickname: nicknameSearch.trim() || "",
      email: emailSearch.trim() || "",
      address: addressSearch.trim() || "",
      app_name: sourceAppSearch?.value || "",
      ip: IPSearch.trim() || "",
      device_model: deviceModelSearch.trim() || "",
      uuid: uuidSearch || "",
      user_type: userTypeSearch,
      country_code: countrySearch?.value || "",
      platform: platFormSearch?.value || "",
      device_os: oSSearch || "",
      type: typeSearch || "",
      status: statusSearch.toString() || "",
      start_date: start_date
        ? formatDateStringToUTC(
            moment(new Date(start_date))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      end_date: end_date
        ? formatDateStringToUTC(
            moment(new Date(end_date)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      //sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        nickname: "",
        email: "",
        address: "",
        ip: "",
        device_model: "",
        uuid: "",
        app_name: "",
        start_date: formatDateStringToUTC(
          moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        end_date: formatDateStringToUTC(
          moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        user_type: "",
        platform: "",
        country_code: "",
        status: "",
        device_os: "",
        type: "",
        sort_by: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setEmailSearch((_prev) => "");
    setAddressSearch((_prev) => "");
    setIPSearch((_prev) => "");
    setDeviceModelSearch((_prev) => "");
    setUUIDSearch((_prev) => "");

    setSourceAppSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setUserTypeSearch("");
    setPlatFormSearch((_prev) => null);
    setOSSearch("");
    setCountrySearch((_prev: any) => null);
    setDateSearch([
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    ]);
    setTypeSearch("");
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 50 }}>
              {referralLogs?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="platform"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    APP_TYPE_OPTIONS?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          return (
            <div style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_REFERRAL_LOG_STATUS[cell?.value?.toString()] ||
                  "secondary"
                }`}
              >
                {t(
                  REFERRAL_LOG_STATUS?.find(
                    (item: any) => item?.value === cell?.value?.toString()
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Failed Reason"),
        accessor: "failed_reason",
        thClass: "whitespace-nowrap",
        filterable: false,
        sortable: false,
        thWidth: 240,
        Cell: (cell: any) => {
          return (
            <div style={{ minWidth: 240 }}>
              {i18n.language === "en"
                ? cell?.value?.en || "-"
                : cell?.value?.ko || "-"}
            </div>
          );
        },
      },
      {
        Header: t("Referral User"),
        accessor: "referrer",
        filterable: false,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          return <GroupInfoUser item={cell?.value} />;
        },
      },
      {
        Header: t("Identify Info"),
        accessor: "identify_info",
        filterable: false,
        sortable: false,
        thWidth: 240,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const value = cell?.value;
          return value ? (
            <div className="text-nowrap" style={{ minWidth: 120 }}>
              <div className="d-flex flex-nowrap">
                <p className="m-0" style={{ width: "70px" }}>
                  {t("Phone")}
                </p>
                <p className="m-0">: {value?.phone_number}</p>
              </div>
              <div className="d-flex flex-nowrap">
                <p className="m-0" style={{ width: "70px" }}>
                  {t("Gender")}
                </p>
                <p className="m-0">: {t(value?.gender)}</p>
              </div>
              <div className="d-flex flex-nowrap">
                <p className="m-0" style={{ width: "70px" }}>
                  {t("Email")}
                </p>
                <p className="m-0">: {value?.email}</p>
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("User Type"),
        accessor: "user_type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_USER_TYPE_REFERRAL_LOG[status] || "seconLdary"
                }`}
              >
                {t(
                  USER_TYPE_REFERRAL_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      // {
      //   Header: t("Operation Mode"),
      //   accessor: "is_guest_mode",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 140,
      //   thClass: "text-center",
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const is_guest_mode = cell?.value;
      //     return (
      //       <div className="text-center" style={{ minWidth: 80 }}>
      //         {String(item?.user_type) ===
      //         String(ENUM_USER_TYPE_LOG.NORMAL_USER) ? (
      //           <span
      //             className={`rounded-pill badge bg-${
      //               COLOR_USER_REAL_GUEST[is_guest_mode] || "secondary"
      //             }`}
      //           >
      //             {t(
      //               GUEST_MODE_OPTION?.find(
      //                 (item: any) =>
      //                   String(item?.value) === String(is_guest_mode)
      //               )?.label || ""
      //             )}
      //           </span>
      //         ) : (
      //           <>-</>
      //         )}
      //       </div>
      //     );
      //   },
      // },
      {
        Header: t("Photo"),
        accessor: "avatar",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => (
          <>
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage((prev) => cell?.value ?? avatar1)}
              >
                <img
                  src={cell?.value ?? avatar1}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = avatar1;
                  }}
                />
              </div>
            </div>
          </>
        ),
      },

      {
        Header: t("Nickname"),
        accessor: "nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "platform",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let platform = cell?.row?.original?.platform;

          let imgPlatform = getPlatFormImage(platform);
          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="platform"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      platform === "default" || platform == "guest"
                        ? "Email"
                        : platform
                    )
                  )}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("deviceOS"),
        accessor: "device_os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.row?.original?.device_os;
          let imgOS = getPlatFormImage(deviceOS);

          return deviceOS ? (
            <div
              className="d-flex align-items-center"
              style={{ minWidth: "110px" }}
            >
              {imgOS ? (
                <div style={{ width: "25px" }} className="me-1">
                  {imgOS ? (
                    <img src={imgOS} width={20} height={20} alt="platform" />
                  ) : (
                    <span
                      className={`bg-secondary`}
                      style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "3px",
                      }}
                    ></span>
                  )}
                </div>
              ) : (
                ""
              )}
              <div>
                {t(
                  LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                    ?.label ?? ""
                )}
              </div>
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("Device Id"),
        accessor: "device_id",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 200,
        Cell: (cell: any) => {
          const deviceId = cell?.row?.original?.device_id;
          return (
            deviceId && (
              <CopyWrapper
                contentCopy={t(`${deviceId}`)}
                style={{ width: 180 }}
              >
                {t(`${deviceId}`)}
              </CopyWrapper>
            )
          );
        },
      },

      {
        Header: t("Device Model"),
        accessor: "device_model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let deviceModel = item?.device_model;
          const os = item?.device_os;

          if (os === "ios") {
            deviceModel = deviceModel
              ? IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ??
                deviceModel
              : "";
          }

          return deviceModel ? (
            <CopyWrapper
              contentCopy={t(`${deviceModel}`)}
              style={{ width: 150 }}
            >
              {t(`${deviceModel}`)}
            </CopyWrapper>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.row?.original?.manufacturer;
          return manufacturer ? (
            <div className="cursor-pointer" style={{ minWidth: "160px" }}>
              <CopyWrapper contentCopy={manufacturer}>
                {`${manufacturer}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("UUID"),
        accessor: "uuid",
        filterable: true,
        sortable: false,
        thWidth: 200,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return item?.uuid ? (
            <div className="cursor-pointer" style={{ minWidth: "160px" }}>
              <CopyWrapper contentCopy={item?.uuid}>
                {`${item?.uuid}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },

      {
        Header: t("App Version"),
        accessor: "app_version",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const row = cell?.row?.original;
          const appVersion = row?.app_build
            ? `${cell?.value} (${row?.app_build})`
            : cell?.value;
          return (
            appVersion && (
              <div className="cursor-pointer" style={{ minWidth: "110px" }}>
                <CopyWrapper contentCopy={appVersion}>
                  {`${appVersion}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("IP"),
        accessor: "ip",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return (
            ip && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      // {
      //   Header: t("Location"),
      //   accessor: "location",
      //   filterable: true,
      //   sortable: false,
      //   thClass: "whitespace-nowrap",
      //   thWidth: 180,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     const lat = item?.lat;
      //     const lng = item?.long;
      //     const country_code = item?.country_code;

      //     return lat || lng ? (
      //       <div className="cursor-pointer" style={{ minWidth: "100px" }}>
      //         <a
      //           href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
      //           target="_blank"
      //           rel="noopener noreferrer"
      //         >
      //           {item?.address || item?.short_address ? (
      //             <>{item?.short_address ?? item?.address}</>
      //           ) : (
      //             <span className="d-flex align-items-center gap-1">
      //               <i className="ri-map-pin-line"></i> {t("Location")}
      //             </span>
      //           )}
      //         </a>
      //       </div>
      //     ) : (
      //       <></>
      //     );
      //   },
      // },

      {
        Header: t("Country"),
        accessor: "country_code",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 120,
        Cell: (cell: any) => {
          const countryCode = cell?.row?.original?.country_code;
          const country = countries.find((item) => item?.code === countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "130px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language === "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, referralLogs?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  useEffect(() => {
    document.title = `${t("Referral Log")} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          countryApi.countries({ page: 1, limit: 20000 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Referral Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title d-flex flex-wrap gap-1 gap-xxl-2 mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          {isReferralLogLoading && query?.page === 1 ? (
                            <Spinner
                              size="sm"
                              className="text-primary"
                            ></Spinner>
                          ) : (
                            <CountUp
                              start={0}
                              end={referralLogs?.pagination?.total || 0}
                              duration={1}
                              className="text-primary"
                            />
                          )}
                          {/* <span className="text-muted">|</span>
                          <span className="d-flex">
                            <div className="me-2">{t("User")}:</div>
                            {isReferralLogLoading ? (
                              <Spinner
                                size="sm"
                                className="text-primary"
                              ></Spinner>
                            ) : (
                              <CountUp
                                start={0}
                                end={
                                  referralLogs?.pagination?.num_of_users || 0
                                }
                                duration={1}
                                className="text-primary"
                              />
                            )}
                          </span> */}
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Nickname")}`}
                          isShow={!!nicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={nicknameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Email")}`}
                          isShow={!!emailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={emailSearch}
                            onChange={(e) => setEmailSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={`${t("IP")}`} isShow={!!IPSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("IP")}...`}
                            value={IPSearch}
                            onChange={(e) => setIPSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("UUID")} isShow={!!uuidSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UUID")}...`}
                            value={uuidSearch}
                            onChange={(e) => setUUIDSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Address")}`}
                          isShow={!!addressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Address")}...`}
                            value={addressSearch}
                            onChange={(e) => setAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="platform"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="device_os"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="country_code"
                            dataList={listCountry || []}
                            placeholder={`${t("Select Country")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_REFERRAL_LOG_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={userTypeSearch}
                            onChangeSelect={(e: any) =>
                              setUserTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_REFERRAL_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={APP_TYPE_OPTIONS || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={sourceAppSearch}
                            onChangeSelect={(e: any) => setSourceAppSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={REFERRAL_LOG_STATUS || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_REFERRAL_LOG_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      {/* <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Event Action")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={LIST_USER_LOG_TYPE_OPTION || []}
                            placeholder={`${t("Event Action")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={typeSearch}
                            onChangeSelect={(e: any) => setTypeSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_LOG_TYPE}
                          />
                        </LabelWrapper>
                      </Col> */}

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!start_date || !!end_date}
                        >
                          <DatePickerCustom
                            startDate={start_date || null}
                            endDate={end_date || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        lg={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={
                        referralLogs?.list?.length ? referralLogs?.list : []
                      }
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={referralLogs?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(referralLogs?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isReferralLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default ReferralLogList;
